(() => {
  if (window.dmrNavigationInitialized) return;
  window.dmrNavigationInitialized = true;
  const desktop = matchMedia('(min-width: 951px)');
  let source = null;
  const menuState = new WeakMap();
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const node = (tag, className, text) => {
    const result = document.createElement(tag);
    if (className) result.className = className;
    if (text !== undefined) result.textContent = text;
    return result;
  };
  const link = (record, className) => {
    const a = node('a', className, record.label);
    a.href = record.url;
    return a;
  };
  const roots = () => source?.roots || [];
  const orderedRoots = () => [...roots().filter(r => normalize(r.label).includes('semi')), ...roots().filter(r => !normalize(r.label).includes('semi'))];
  const findNode = id => {
    const search = rows => {
      for (const row of rows) { if (row.id === id) return row; const found = search(row.children || []); if (found) return found; }
      return null;
    };
    return search(roots());
  };
  const explicitYears = record => {
    const title = record.label || '';
    if (/après|apres|avant|depuis|toutes|all years|onwards|\+/i.test(title)) return [];
    const range = title.match(/\b((?:19|20)\d{2})\s*[-–/]\s*((?:19|20)\d{2})\b/);
    if (range) { const first = Number(range[1]), last = Number(range[2]); return last >= first && last - first < 70 ? Array.from({length:last-first+1}, (_, i) => last-i) : []; }
    return [...new Set((title.match(/\b(?:19|20)\d{2}\b/g) || []).map(Number))].sort((a,b) => b-a);
  };
  const leaves = (record, trail = []) => record.children?.length ? record.children.flatMap(child => leaves(child, [...trail, record.label])) : [{...record, context:trail.join(' · '), years:explicitYears(record)}];
  const finderRoots = () => source?.finder_roots?.length ? source.finder_roots : roots();
  const YEAR_TOKEN = /(?:\b(?:avant|après|apres|depuis|from|before|after|since)\s+(?:19|20)\d{2}\b|\b(?:19|20)\d{2}\s*[-–/]\s*(?:19|20)\d{2}\b|\b(?:19|20)\d{2}\b)/gi;
  const familyOf = label => String(label || '').replace(/\([^)]*(?:ann[ée]es?|years?)[^)]*\)/gi, ' ').replace(YEAR_TOKEN, ' ').replace(/\(\s*\)/g, ' ').replace(/\s+/g, ' ').trim();
  const yearsOf = label => (String(label || '').match(YEAR_TOKEN) || []).map(s => s.trim()).join(' · ');
  const grouped = records => {
    const families = new Map();
    records.forEach(record => {
      const family = familyOf(record.label) || record.label;
      const key = normalize(family);
      if (!families.has(key)) families.set(key, {id:'g-'+record.id, label:family, url:null, generations:[]});
      families.get(key).generations.push({...record, yearLabel:yearsOf(record.label) || source.strings.all_years});
    });
    return [...families.values()].map(group => (group.generations.length === 1 && !yearsOf(group.generations[0].label)) ? {...group.generations[0]} : group);
  };
  const catalogue = () => finderRoots().filter(root => root.children?.length && !source.excluded.map(s => s.trim()).includes(root.handle)).map(root => {
    const flat = root.children.every(child => !child.children?.length);
    return {...root, flat, models:flat ? grouped(root.children.map(record => ({...record, years:explicitYears(record)}))) : [], brands:flat ? [] : root.children.map(brand => ({...brand, models:brand.children?.length ? grouped(leaves(brand)) : [{...brand, label:source.strings.choose_models, years:explicitYears(brand)}]})).sort((a,b) => a.label.localeCompare(b.label, document.documentElement.lang))};
  });
  const navRootFor = record => {
    if (!record) return undefined;
    const token = value => (normalize(value).match(/[a-z0-9]+/) || [''])[0];
    const match = roots().find(root => root.handle === record.handle) || roots().find(root => root.children?.length && token(root.label) && token(root.label) === token(record.label));
    return match?.id;
  };
  const getState = header => {
    if (!menuState.has(header)) menuState.set(header, {path:[],query:''});
    return menuState.get(header);
  };
  const openMenu = (header, categoryId) => {
    if (!header || !source) return;
    const state = getState(header);
    state.path = categoryId && findNode(categoryId)?.children?.length ? [categoryId] : [];
    if (desktop.matches && !state.path.length) state.path = [roots().find(r => r.children?.length)?.id].filter(Boolean);
    state.query = '';
    header.querySelector('[data-dmr-nav-query]').value = '';
    renderMenu(header);
    const dialog = header.querySelector('[data-dmr-nav-dialog]');
    if (!dialog.open) dialog.showModal();
    header.querySelector('[data-dmr-nav-title]').focus();
  };
  const renderMenu = header => {
    const state = getState(header), t = source.strings;
    const selected = findNode(state.path.at(-1));
    const category = findNode(state.path[0]);
    const title = header.querySelector('[data-dmr-nav-title]');
    title.textContent = selected?.label || t.all_shop;
    const sidebar = header.querySelector('[data-dmr-nav-sidebar]');
    sidebar.replaceChildren();
    orderedRoots().forEach(root => {
      if (!root.children?.length) sidebar.append(link(root));
      else {
        const button = node('button', '', root.label); button.type = 'button'; button.dataset.dmrSelectRoot = root.id;
        button.setAttribute('aria-current', String(category?.id === root.id)); sidebar.append(button);
      }
    });
    source.guides.filter(g => g.url).forEach(g => sidebar.append(link(g)));
    const back = header.querySelector('[data-dmr-nav-back]');
    back.hidden = !state.path.length;
    header.querySelector('[data-dmr-nav-breadcrumb]').textContent = state.path.slice(0,-1).map(id => findNode(id)?.label).filter(Boolean).join(' / ');
    const overview = header.querySelector('[data-dmr-nav-overview]');
    overview.hidden = !selected || selected.url === source.home || selected.type === 'frontpage_link';
    if (selected) {overview.href=selected.url; overview.textContent=t.view_all+' : '+selected.label;}
    const list = header.querySelector('[data-dmr-nav-items]');
    const result = header.querySelector('[data-dmr-nav-results]');
    list.replaceChildren();
    list.className = '';
    const query = normalize(state.query);
    let count = 0;
    if (desktop.matches && selected && !query) {
      list.className = 'dmr-nav-columns';
      for (const group of selected.children || []) {
        const article = node('section','dmr-nav-brand');
        if (group.children?.length) {
          const h = node('h3','',group.label); article.append(h);
          leaves(group).forEach(model => {article.append(link(model,'dmr-nav-model'));count++;});
        } else { article.append(link(group,'dmr-nav-direct')); count++; }
        list.append(article);
      }
    } else if (query) {
      list.className = 'dmr-nav-search-results';
      // 16/10/2026 : la recherche couvre TOUTES les catégories (ex. « MT 07 » tapé depuis 50cc), celle ouverte en premier, sans doublons.
      const seen = new Set();
      const candidates = [...(selected ? leaves(selected) : []), ...roots().flatMap(root => leaves(root))].filter(model => { const k = (model.url || '') + '|' + normalize(model.label); if (seen.has(k)) return false; seen.add(k); return true; });
      const compact = value => normalize(value).replace(/[^a-z0-9]+/g, '');
      const compactQuery = compact(query);
      candidates.filter(model => normalize(model.context+' '+model.label).includes(query) || (compactQuery && compact(model.context+' '+model.label).includes(compactQuery))).forEach(model => {
        const a=link(model,'dmr-nav-search-result');
        if(model.context){const context=node('small','',model.context);a.prepend(context);}
        list.append(a);count++;
      });
    } else {
      const rows = selected?.children || orderedRoots();
      const brandGrid = Boolean(selected && rows.some(row => row.children?.length));
      list.className = brandGrid ? 'dmr-nav-brand-grid' : 'dmr-nav-mobile-list';
      rows.forEach(row => {
        if (row.children?.length) {
          const button = node('button','dmr-nav-next',row.label);button.type='button';button.dataset.dmrEnter=row.id;
          const arrow=node('span','','→');arrow.setAttribute('aria-hidden','true');button.append(arrow);list.append(button);
        } else list.append(link(row,'dmr-nav-leaf'));
        count++;
      });
      if(!selected) source.guides.filter(g=>g.url).forEach(g=>list.append(link(g,'dmr-nav-leaf')));
    }
    result.textContent = count ? (query || desktop.matches ? t.results+' '+count : '') : t.no_results;
    header.querySelector('[data-dmr-nav-query]').setAttribute('aria-label',t.search_models);
  };
  const initFinder = form => {
    if (!source) return;
    const container = form.closest('.dmr-finder');
    const selects = ['category','brand','model','year'].map(name=>form.querySelector(`[name="${name}"]`));
    const [category,brand,model,year]=selects;
    const yearField=form.querySelector('[data-dmr-year-field]');
    const status=container.querySelector('[data-dmr-finder-status]'),t=source.strings;
    const data=catalogue();
    const categoryRecord=()=>data.find(row=>row.id===category.value);
    const brandRecord=()=>categoryRecord()?.brands.find(row=>row.id===brand.value);
    const modelRecord=()=>categoryRecord()?.flat ? categoryRecord().models.find(row=>row.id===model.value) : brandRecord()?.models.find(row=>row.id===model.value);
    const yearRecord=()=>modelRecord()?.generations?.find(row=>row.id===year.value);
    const destination=()=>{const record=modelRecord();if(!record)return null;return record.generations?(yearRecord()||null):record;};
    const options = (select,records,placeholder,labelKey='label') => {select.replaceChildren(new Option(placeholder,''));records.forEach(row=>select.add(new Option(row[labelKey],row.id)));select.disabled=!records.length;};
    const syncYear=()=>{const generations=modelRecord()?.generations||[];const show=generations.length>0;if(yearField)yearField.hidden=!show;if(year){year.required=show;options(year,generations,t.pick_year,'yearLabel');if(generations.length===1)year.value=generations[0].id;}form.classList.toggle('dmr-bike-form-year',show);};
    const message = () => {
      const record=modelRecord(),target=destination();status.replaceChildren();
      if(target)status.textContent=(brandRecord()?.label?brandRecord().label+' · ':'')+record.label+(record.generations?' · '+target.yearLabel:'')+'. '+t.ready;
      else if(record)status.textContent=t.pick_year+'.';
      else{status.append(document.createTextNode(t.finder_help+' '));const a=node('a','',t.ask_whatsapp);a.href=source.whatsapp;status.append(a);}
      form.dispatchEvent(new CustomEvent('dmr:bike-change',{bubbles:true,detail:target?{category:categoryRecord().label,brand:brandRecord()?.label||null,model:record.label,year:target.yearLabel||null,url:target.url,nodeId:target.id}:null}));
    };
    options(category,data,t.pick_category);options(brand,[],t.pick_brand);options(model,[],t.pick_model);syncYear();
    form.hidden=false;container.querySelector('[data-dmr-finder-open-menu]').hidden=false;
    form.onchange=event=>{
      if(event.target===category){const record=categoryRecord();const flat=record?.flat;form.querySelector('[data-dmr-brand-field]').hidden=Boolean(flat);brand.required=!flat;form.classList.toggle('dmr-bike-form-flat',Boolean(flat));options(brand,record?.brands||[],t.pick_brand);options(model,flat?record.models:[],t.pick_model);syncYear();message();}
      else if(event.target===brand){const records=brandRecord()?.models||[];options(model,records,t.pick_model);if(records.length===1)model.value=records[0].id;syncYear();message();}
      else if(event.target===model){syncYear();message();}
      else if(event.target===year)message();
    };
    form.onsubmit=event=>{event.preventDefault();const target=destination();if(target)location.assign(target.url);else{status.textContent=modelRecord()?t.pick_year+'.':t.incomplete;selects.find(select=>select&&!select.disabled&&!select.value)?.focus();}};
    container.querySelector('[data-dmr-finder-open-menu]').onclick=()=>openMenu(document.querySelector('[data-dmr-navigation]'),navRootFor(categoryRecord()));
    message();
  };
  const initialise = () => {
    const sourceElement=document.querySelector('[data-dmr-nav-source]');
    if(!sourceElement)return;
    try{source=JSON.parse(sourceElement.textContent);}catch(_){return;}
    document.querySelectorAll('[data-dmr-navigation]').forEach(header=>{
      if(header.dataset.dmrReady)return;header.dataset.dmrReady='true';
      header.querySelector('[data-dmr-open-menu]').addEventListener('click',event=>{event.preventDefault();openMenu(header);});
      const dialog=header.querySelector('[data-dmr-nav-dialog]');
      dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();});
      header.querySelector('[data-dmr-nav-query]').addEventListener('input',event=>{getState(header).query=event.target.value;renderMenu(header);});
    });
    document.querySelectorAll('[data-dmr-finder]').forEach(initFinder);
    document.dispatchEvent(new CustomEvent('dmr:navigation-ready'));
  };
  // 16/10/2026 : la loupe ouvre la recherche ET place le curseur dans le champ (avant : 2 clics, la loupe puis le champ).
  // Fait dans le clic lui-même pour que le clavier s'ouvre aussi sur iPhone.
  document.addEventListener('click',event=>{
    const summary=event.target.closest('details.dmr-search>summary');
    if(!summary)return;
    const details=summary.parentElement;
    if(details.open)return;
    const input=details.querySelector('input[name="q"]');
    if(!input)return;
    event.preventDefault();
    details.open=true;
    input.focus();
  });
  document.addEventListener('click',event=>{
    const target=event.target.closest('[data-dmr-open-root],[data-dmr-close-menu],[data-dmr-select-root],[data-dmr-enter],[data-dmr-nav-back]');
    if(!target||!source)return;
    const header=target.closest('[data-dmr-navigation]');if(!header)return;
    if(target.matches('[data-dmr-open-root]')){event.preventDefault();openMenu(header,target.dataset.dmrOpenRoot);return;}
    if(target.matches('[data-dmr-close-menu]')){header.querySelector('[data-dmr-nav-dialog]').close();return;}
    const state=getState(header);
    if(target.matches('[data-dmr-select-root]'))state.path=[target.dataset.dmrSelectRoot];
    else if(target.matches('[data-dmr-enter]'))state.path.push(target.dataset.dmrEnter);
    else state.path.pop();
    state.query='';header.querySelector('[data-dmr-nav-query]').value='';renderMenu(header);header.querySelector('[data-dmr-nav-title]').focus();
  });
  desktop.addEventListener('change',()=>{document.querySelectorAll('[data-dmr-navigation]').forEach(header=>{const state=getState(header);if(desktop.matches){state.path=state.path.length?[state.path[0]]:[roots().find(root=>root.children?.length)?.id].filter(Boolean);}if(source)renderMenu(header);});});
  document.addEventListener('change',event=>{if(event.target.matches('[data-dmr-lang]')&&event.target.form)event.target.form.submit();});
  const rootForLabel = label => {
    const token = (normalize(label).match(/[a-z0-9]+/) || [''])[0];
    if (!token) return null;
    return roots().find(root => root.children?.length && (normalize(root.label).replace(/[^a-z0-9]+/g,' ').trim().split(' ')[0] === token || normalize(root.label).startsWith(token.slice(0,4)) || token.startsWith(normalize(root.label).replace(/[^a-z0-9]/g,'').slice(0,4)))) || null;
  };
  document.addEventListener('click',event=>{
    const target=event.target.closest('[data-dmr-open-category]');
    if(!target||!source)return;
    const header=document.querySelector('[data-dmr-navigation]');
    const root=rootForLabel(target.dataset.dmrOpenCategory);
    if(!header||!root)return;
    event.preventDefault();
    openMenu(header,root.id);
  });
  document.addEventListener('shopify:section:load',initialise);
  document.addEventListener('shopify:section:unload',event=>{event.target.querySelectorAll('[data-dmr-nav-dialog]').forEach(dialog=>dialog.close());});
  const updateCartBadge=cart=>{
    if(!cart)return;
    const count=Array.isArray(cart.items)?cart.items.filter(item=>!Object.prototype.hasOwnProperty.call(item.properties||{},'_gpo_parent_product_group')).reduce((total,item)=>total+Number(item.quantity||0),0):cart.item_count;
    if(typeof count!=='number')return;
    document.querySelectorAll('[data-dmr-cart-count]').forEach(badge=>{badge.textContent=String(count);badge.hidden=count===0;});
  };
  let cartRefreshTimer;
  document.addEventListener('theme:cartchanged',()=>{
    clearTimeout(cartRefreshTimer);
    cartRefreshTimer=setTimeout(async()=>{
      const url=document.querySelector('[data-dmr-cart-url]')?.dataset.dmrCartUrl;
      if(!url)return;
      try{const response=await fetch(url,{headers:{Accept:'application/json'},credentials:'same-origin'});if(response.ok)updateCartBadge(await response.json());}catch(_){}
    },100);
  });
  document.addEventListener('cart:updated',event=>updateCartBadge(event.detail?.cart||event.detail));
  window.DMRNavigation={explicitYears,catalogue,getSource:()=>source};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialise,{once:true});else initialise();
})();
